import React, { useEffect, useState, useRef } from 'react'
import api from '../../../seller-apis/api'
import { revokedOnly } from '../../../seller-apis/apidataField'
import { Container, Modal, ProgressBar } from 'react-bootstrap';
import OrderCardWeb from '../../common/OrderCardWeb';
import Popup from '../../common/Popup';
import TrackOrderPopup from '../../common/TrackOrder-Popup';
import PaginationCom from '../../common/Pagination';
import servicesApi from '../../../seller-apis/servicesApi';
import { useAlert } from 'react-alert';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange, REVOKED_ORDER_DATE_DAYS } from '../useOrderDateAlert';
import { variables } from '../../../Variables.json'
import axios from 'axios';
import OrderSKUSearch from '../../common/ProductSearch/OrderSKUSearch';
import moment from 'moment';
import MainLoader from '../../common/Loader/PageLoader';
import { useSelector } from 'react-redux';
// var dateFromWeb;
// var dateToWeb;
// Images related
var imagesName = [];
var s3Urls = [];
var imagesNamePackage = []

// Videos related
var videosName = [];
var vids3Urls = [];
var currentLink;
var currReportImg;
var globalFilter = {
    "pageNo": 1,
    "spclFilter": {
        "products.tracks.rStatus" : { "$ne": "RTO-Delivered" },
        "status": {"$in": ["RTO", "Partially delivered/RTO"]},
        // "products.tracks.rStatus-Id": "RTO-InTransit"
        // "rStatus": "RTO-InTransit"
    },
    "sortFilter": {
        "rtoDate": -1
    }
};

const Revoked_InTransit = () => {
    var outerdiv;
    var loaderDiv;
    const alert = useAlert();
    const stateData = useSelector(state => state?.ActionReducer);
    const [addressName, setAddressName] = useState("");
    const showOrderDateAlert = useOrderDateAlert(alert);

    const updateOrderFromDate = (value) => {
        const { from, to } = resolveOrderDateRange('from', value, dateFromWeb, dateToWeb);
        setDateFromWeb(from);
        setDateToWeb(to);
    };

    const updateOrderToDate = (value) => {
        const { from, to } = resolveOrderDateRange('to', value, dateFromWeb, dateToWeb);
        setDateFromWeb(from);
        setDateToWeb(to);
    };

    // Web states
    const [allRevokes, setallRevokes] = useState([]);
    const [allRecords, setallRecords] = useState();
    const [ennewloader, setennewloader] = useState();

    // Pagination related

    const [selectedPage, setSelectedPage] = useState(1);
    const [compforPaginationweb, setcompforPaginationweb] = useState("rto");


    //Product Detail Popup

    const [productDetail, setproductDetail] = useState([
        {
            "description": undefined,
            "sdescription": undefined,
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
        }
    ]);
    const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
    const [defUrl, setdefUrl] = useState();

    // Web filter related states
    const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("none");
    const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
    const [selectedTrackwithin, setselectedTrackwithin] = useState(0);
    const [detailPPrice, setdetailPPrice] = useState("0");
    const [rtoAddress, setrtoAddress] = useState();
    const [searchType, setSearchType] = useState("Product Name");


    // Sort Filter States
    const [sortdatefrom, setsortdatefrom] = useState();
    const [sortdateto, setsortdateto] = useState();


    // const [sortHistdatefrom, setHistsortdatefrom] = useState(moment().subtract(29, 'days').format('YYYY-MM-DD'));
    // const [sortHistdateto, setHistsortdateto] = useState(moment().format('YYYY-MM-DD'));
    const [dateFromWeb, setDateFromWeb] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [dateToWeb, setDateToWeb] = useState(moment().format('YYYY-MM-DD'));

    // Web filter related states

    const [orderId, setOrderId] = useState(undefined);
    const [orderName, setorderName] = useState()


    // Modal rto undelivered,report damage
    const [show, setShow] = useState(false);
    const [rtoaction, setrtoaction] = useState("");
    const [damagecomment, setdamagecomment] = useState("")
    const [CurrReportId, setCurrReportId] = useState(0)
    const [CurrReportDate, setCurrReportDate] = useState(0)
    const [ReportType, setReportType] = useState(undefined)
    const [DayDiffer, setDayDiffer] = useState()
    const [RTOClosedDate, setRTOClosedDate] = useState()
    const [RTODeliverDate, setRTODeliverDate] = useState()
    // Images Related 
    const [urlList, seturlList] = useState([]);
    const [urlListshow, seturlListshow] = useState(true);
    const [imgprogress, setimgprogress] = useState();
    const [urlListPackage, seturlListPackage] = useState([]);
    const [urlListshowPackage, seturlListshowPackage] = useState(true);
    const [imgprogressPackage, setimgprogressPackage] = useState();
    const [minValDate, setMinValDate] = useState("")
    // Videos related
    const [vidurlList, setvidurlList] = useState([]);
    const [vidurlListshow, setvidurlListshow] = useState(true);
    const [progress, setProgress] = useState()

    const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"))
    const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
    
    //SL-675
    const [totalRcordId, setTotalReordId] = useState([]);
    //<Start-Here> Track button Issue | Ticket : SL-950
    const [selectedTransitDetail, setSelectedTransitDetail] = useState([]);
    const [selectedPopupId, setSelectedPopupId] = useState(null);
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false; // skip first render
            return;
        }
        
        if(isPopupTrackVisWeb == "none") 
          setpopupVisibilitytrackWeb(true);
    }, [selectedTransitDetail]);
    //</End-Here> Track button Issue | Ticket : SL-950

    useEffect(() => {
        const { from, to } = resetOrderDateFilter();
        setDateFromWeb(from);
        setDateToWeb(to);
        globalFilter = {
            ...globalFilter,
            "pageNo": 1,
            "spclFilter": {
                "products.tracks.rStatus": { "$ne": "RTO-Delivered" },
                "status": { "$in": ["RTO", "Partially delivered/RTO"] },
            }
        };
        applyFilter();
    }, [])

    useEffect(() => {
        if (rtoAddress === "" || rtoAddress === null) {
            setrtoAddress(undefined)
        }
    }, [rtoAddress])


    useEffect(() => {
        if (orderId === "" || orderId === null) {
            setOrderId(undefined)

            if (globalFilter?.filters?.["orderId-Id"]) {
                delete globalFilter.filters?.["orderId-Id"]
                globalFilter.pageNo = 1;
                setSelectedPage(1)
                getOrders()
            }
        }
    }, [orderId])


    useEffect(() => {
        if (orderName === "" || orderName === null) {
            setorderName(undefined)
        }
    }, [orderName])

    const getOrders = () => {
        try {
            applyLoader()
            api.order.revokedOrders(revokedOnly(globalFilter))
                .then((res) => {
                    removeLoader();
                    setallRevokes(res.data);
                    setallRecords(res.totalRecords);
                    if (totalRcordId?.length === 0) { // SL-675
                        setTotalReordId(res?.productId);
                        globalFilter["productId"] = false;
                    }
                })
                .catch((err) => {
                    removeLoader();
                    console.log(err);
                });
        } catch (err) {
            removeLoader()
            console.log(err)
        }
    }

    const handleClose = () => {
        setShow(false)
        seturlList([])
        seturlListPackage([])
        setvidurlList([])
        imagesName = []
        imagesNamePackage = []
        s3Urls = []
        videosName = []
        vids3Urls = []
        seturlListshow(false)
        seturlListshowPackage(false)
        setvidurlList(true)
        setrtoaction("")
        setdamagecomment("")
    }
    const handleShow = () => setShow(true);



    // Popup showing detail


    function detail(data, price) {
        console.log(data)
        setdetailPPrice(price)
        if (data && data[0] === undefined) {
            setproductDetail(
                [
                    {
                        "description": "No details available",
                        "sdescription": "No short description",
                        "name": undefined,
                        "price": undefined,
                        "SKU": undefined,
                        "popupVisibility": undefined,
                        "images": []
                    }
                ]
            )
        }
        else {
            setproductDetail(data)
        }
    }


    function setpopupVisibilityDetail(e) {
        if (e) {
            setisDetailPopupVis("block")
        }
        else {
            setisDetailPopupVis("none")
        }
    }



    function setpopupVisibilitytrackWeb(e) {
        if (e) {
            setisPopupTrackVisWeb("block")
        }
        else {
            setisPopupTrackVisWeb("none")
        }
    }





    function trackPopupWeb(e, trackNo) {
        setselectedtrackOrderWeb(e)
        setselectedTrackwithin(trackNo)
    }

    // apply loaders

    function applyLoader() {
        outerdiv = document.getElementById("orDeskContain");
        loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
    }


    function paginate(data) {
        applyLoader()
        setselectedtrackOrderWeb("0")
        setselectedTrackwithin("0")
        setCurrReportId(0)
        setSelectedPage(data.number)
        globalFilter.pageNo = data.number
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            setallRevokes(res.data)
            removeLoader()
        }).catch(err => console.log(err))
    }

    // function to clear date
    function clearDate() {
        setDateFromWeb("")
        setDateToWeb("")
        setsortdatefrom("")
        setsortdateto("")
    }

    function checkevent(e, spcl,value) {
        if (e.keyCode === 13) {
            globalFilter.filters = {
                ...globalFilter.filters, "orderId-Id": orderId
            }
            if (spcl === "orderId") {
                globalFilter.pageNo = 1;

                if (orderId === "" || orderId === undefined) {
                    if (compforPaginationweb !== "rto") {
                        setSelectedPage(1)
                        applyLoader()
                        setcompforPaginationweb("rto")
                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            console.log(res)
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => {
                            removeLoader()
                            console.log(err)
                        })
                    }
                }
                else {
                    applyLoader()
                    setSelectedPage(1)
                    api.order.revokedOrders(revokedOnly(globalFilter)).then(res => {
                        setcompforPaginationweb("orderId")
                        setremoveFilterClass("invent_remove_filter_btn_active")
                        console.log(res)
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => {
                        console.log(err)
                        removeLoader()
                    })
                }
            }
            else if (spcl === "rtoaddress") {
                if (value === "" || value === undefined) {
                    if (compforPaginationweb !== "rto") {
                         delete globalFilter.filters["products.vendorDetails.addrName"]
                        setSelectedPage(1)
                        globalFilter.pageNo = 1;
                        applyLoader()
                        setcompforPaginationweb("rto")
                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            console.log(res)
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => {
                            removeLoader()
                            console.log(err)
                        })
                    }
                }
                else {
                    globalFilter.filters = {
                        ...globalFilter.filters, "products.vendorDetails.addrName": value
                    }
                    applyLoader()
                    setSelectedPage(1)
                    setremoveFilterClass("invent_remove_filter_btn_active")
                    globalFilter.pageNo = 1;
                    api.order.revokedOrders(revokedOnly(globalFilter)).then(res => {
                        setcompforPaginationweb("rtoaddress")
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => {
                        console.log(err)
                        removeLoader()
                    })
                }
            }
            else {
                let ordersearchFilter=searchType!='sku'?{"products.productId._id": orderName}:{"products.productId._id": orderName};
                globalFilter.filters = {
                    // ...globalFilter.filters, 
                    ...ordersearchFilter
                }
                if (orderName === "" || orderName === undefined) {
                    if (compforPaginationweb !== "rto") {
                        setSelectedPage(1)
                        applyLoader()
                        setcompforPaginationweb("rto")
                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            console.log(res)
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => {
                            removeLoader()
                            console.log(err)
                        })
                    }
                }
                else {
                    applyLoader()
                    setSelectedPage(1)
                    api.order.revokedOrders(revokedOnly(globalFilter)).then(res => {
                        setremoveFilterClass("invent_remove_filter_btn_active")
                        setcompforPaginationweb("pName")
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => {
                        console.log(err)
                        removeLoader()
                    })
                }


            }
        }
    }


    // Function to restore default
    function defaultweb() {
        setSelectedPage(1)
        clearDate()
        setOrderId("");
        setorderName("");
        let filterData = {
            "pageNo": "1"
        }
        api.order.revokedOrders(revokedOnly(filterData)).then((res) => {
            console.log(res)
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
            setcompforPaginationweb("rto")
        }).catch(err => console.log(err))
    }




    useEffect(() => {
        if (allRecords < 1) {
            alert.show('No Orders Found', {
                "type": "info",
                "timeout": "7000"
            })
        }
    }, [allRecords])




    function passValidamage() {
        if (imagesNamePackage.length < 1) {
            return { "status": false, "msg": "Please upload package image(s)." }
        }
        else if (imagesName.length < 1) {
            return { "status": false, "msg": "Please upload product image(s)." }
        }
        else if (videosName.length < 1) {
            return { "status": false, "msg": "Please upload a video." }
        }
        else if (damagecomment.length < 1) {
            return { "status": false, "msg": "Please add desciption." }
        }
        return { "status": true, "msg": "Successfully reported." }
    }

    // Handle report func

    function handleReportRto(id) {
        let notRepDate = new Date(allRevokes[id].products[0].tracks[0].transitDetail[allRevokes[id].products[0].tracks[0].transitDetail.length - 1].timestamp);
        let notDt = notRepDate.toUTCString(allRevokes[id].products[0].tracks[0].transitDetail[allRevokes[id].products[0].tracks[0].transitDetail.length - 1].timestamp);
        let str_rtoondate = notDt.substr(4, 12);
        let tDDate = new Date();
        var diffDate = tDDate.getTime() - notRepDate.getTime();
        var daydiffer = diffDate / (1000 * 60 * 60 * 24);
        let reportCloseD = notRepDate;
        setCurrReportId(id)
        setRTODeliverDate(str_rtoondate)
        setDayDiffer(daydiffer)
        reportCloseD.setDate(notRepDate.getDate() + 2)
        let d = reportCloseD.toUTCString(reportCloseD)
        setRTOClosedDate(d.substr(4, 12))
        setReportType(undefined)
        if (allRevokes[id].products[0] && allRevokes[id].products[0].rtoReportType) {
            setReportType(allRevokes[id].products[0].rtoReportType)
            let dt = new Date(allRevokes[id].products[0].rtoReportMailSentDate);
            let d = dt.toUTCString(allRevokes[id].products[0].rtoReportMailSentDate);
            let str_mailsentdate = d.substr(4, 12)
            setCurrReportDate(str_mailsentdate)
        }

        handleShow()
    }


    //   Report undelivered rto's

    function reportUndeliveredFunc() {

        let data = {
            "reportType": "Undelivered",
            "order": allRevokes[CurrReportId].orderId,
            "packageImage": [],
            "productImage": [],
            "video": "",
            "status": "OPEN",
            "sellerNote": "",
        }
        api.rto.reportRto(data).then((res) => {
            console.log(res)
            if (res.message === "Success") {
                handleClose()
                alert.success("Reported to Toolsvilla.We will get back to you soon")
                applyLoader()
                api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                    setallRevokes(res.data)
                    setallRecords(res.totalRecords)
                    removeLoader()
                }).catch(err => console.log(err))
            }
        }).catch(err => console.log(err))
    }

    function clearFilter() {
        setDateFromWeb("")
        setDateToWeb("")
        setorderName("")
        setrtoAddress("")
        setOrderId("")
        // setHistsortdatefrom("")
        // setHistsortdateto("")
        applyLoader()
        globalFilter = {
            "pageNo": 1,
            "spclFilter": {
                // "products.tracks.rStatus-Id": "RTO-InTransit"
                "products.tracks.rStatus" : { "$ne": "RTO-Delivered" },
                "status": {"$in": ["RTO", "Partially delivered/RTO"]}
            }
        }
        setSelectedPage(1)
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            setremoveFilterClass("invent_remove_filter_btn")
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
            removeLoader()
        }).catch(err => console.log(err))
    }

    // function setdateweb(e, type) {
    //     if (type === "from") {
    //         dateFromWeb = e.target.value;
    //         setHistsortdatefrom(e.target.value)
    //       }
    //       else {
    //         dateToWeb = e.target.value;
    //         setHistsortdateto(e.target.value)
    //       }
    //       if (dateFromWeb !== undefined && dateToWeb != undefined) {
    //         let fromDate = new Date(dateFromWeb)
    //         let toDate = new Date(dateToWeb);
    //         let diffDate = toDate.getTime() - fromDate.getTime()
    //         let daydiffer = diffDate / (1000 * 60 * 60 * 24);
    //         daydiffer = Math.floor(daydiffer)
    //         console.log(daydiffer)
    //         if (daydiffer > 60) {
    //           alert.info('Date range cannot be more than 60 days.', { position: 'top center' })
    //         }
    //         else if (daydiffer < 0) {
    //           alert.info("Please select a valid date range.")
    //         }
    //       }
    // }

   function applyFilter() {
    setselectedtrackOrderWeb(0);
    setSelectedPage(1);
    globalFilter.pageNo = 1;

    // Use fallback defaults if state is empty
    const fromDateValue = dateFromWeb || moment().subtract(30, 'days').format('YYYY-MM-DD');
    const toDateValue = dateToWeb || moment().format('YYYY-MM-DD');

    if (!fromDateValue || !toDateValue) {
        showOrderDateAlert("please select both dates", "show");
        return false;
    }

    // Calculate date difference
    const fromDate = new Date(fromDateValue);
    const toDate = new Date(toDateValue);
    let daydiffer = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    if (daydiffer > 60) {
        showOrderDateAlert("Date range cannot be more than 60 days.");
        return 0;
    }

    // Always set date filter
    globalFilter.spclFilter = {
        ...globalFilter.spclFilter,
        "from-rtoDate": fromDateValue + "T00:00:00",
        "to-rtoDate": toDateValue + "T23:59:59"
    };

    // Set other filters
    globalFilter.filters = {
        ...globalFilter.filters,
        "products.productId.productName": orderName,
        "products.vendorDetails.addrName-Id": rtoAddress,
        "orderId-Id": orderId
    };

    applyLoader();

    // Set remove filter button state
    if (orderId || orderName || rtoAddress || (fromDateValue && toDateValue)) {
        setremoveFilterClass("invent_remove_filter_btn_active");
    }

    // SL-675: control productId
    globalFilter["productId"] = totalRcordId && totalRcordId?.length === 0;

    api.order.revokedOrders(revokedOnly(globalFilter))
        .then((res) => {
            removeLoader();
            setdefUrl("manual-mandava-weeder");
            setallRevokes(res.data);
            setallRecords(res.totalRecords);

            if (totalRcordId?.length === 0) { // SL-675
                setTotalReordId(res?.productId);
                globalFilter["productId"] = false;
            }

        })
        .catch((err) => {
            removeLoader();
            console.log(err);
        });
}

    //<Start-Here> Serach Ticket: SL-675
    const filterSearch=(data)=>{
        //setorderName(data.data);
        //setSearchType(data.type)
        applyLoader();
        globalFilter['filters'] = { ...globalFilter.filters, "products.productId._id": data.data }
        //Search Issue on Other than 1st Page SL-698 and SL-675
        if(globalFilter?.searchIds)
            delete globalFilter['searchIds'];
        globalFilter.pageNo = 1;
        setSelectedPage(1)
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            removeLoader()
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
        }).catch(err => {
            removeLoader()
            console.log(err)
        })
      }
   
    /**
   * API Calling
   */
    const ApiCalling = (flag) => {
        applyLoader()
        if(globalFilter?.searchIds)
          delete globalFilter['searchIds'];
        globalFilter.pageNo = selectedPage;
        if(flag === "reset"){
            delete globalFilter.filters["products.productId._id"];
            globalFilter.pageNo = 1;
            setSelectedPage(1)
        }
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            removeLoader()
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
        }).catch(err => {
            removeLoader()
            console.log(err)
        })
    }
  
   /**
    * Search By Keyword On Enter
    */
    const searchByKeyword = (value, type, productIds) => {
      
      if(productIds.length > 0){
        applyLoader()
        //   if (type === "sku") {
        //       globalFilter['filters'] = { ...globalFilter.filters, "products.productId._id": productIds?.[0] }
        //       if (globalFilter?.searchIds)
        //           delete globalFilter['searchIds'];
        //   }
        //   else {
        //       globalFilter['searchIds'] = productIds
        //   }
        globalFilter['searchIds'] = productIds
        //Search Issue on Other than 1st Page SL-698 and SL-675
        globalFilter.pageNo = 1;
        setSelectedPage(1);
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            removeLoader()
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
        }).catch(err => {
            removeLoader()
            console.log(err)
        })
      }
      else{
        setallRevokes([]);
        setallRecords(0);
        
      }
    }
    //</End-Here> Serach Ticket: SL-675

    
      useEffect(()=>{
        checkevent({ "keyCode": 13 }, "name");
      },[orderName])
    //<Start-here> Ticket : SL-896
    const exportRTOOrders = () => {
        try {
            let btn = document.getElementById("export_Btn");
            btn.innerHTML = `Generating Sheet<span id="dot1"><i class="bi bi-dot"></i></span><span id="dot2"><i class="bi bi-dot"></i></span><span id="dot3"><i class="bi bi-dot"></i></span>`
            api.order.exportRevokedOrders(revokedOnly(globalFilter))
            .then((res) => {
                btn.innerHTML = `Export`;
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement("a");
                link.href = url;
                link.download = dateFromWeb ? `RTO-Orders-${dateFromWeb}.xlsx` : "RTO-Orders.xlsx";
                link.click();
            }).catch(err => {
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
        
    }
    //<End-here> SL-896
    return (
        <>
            <div className="" id="orDeskContain">
                {/* New orders desktop */}
                <div class="tab">
                <div className='d-flex mb-3 justify-content-around'>
                        {/* ******** */}
                        <div className='theme-shed1 p-2'>
                            <div className='m-auto mt-1'>
                                <span className='payment_dates'>RTO Marked Date -  From: <input type='date' max={dateToWeb || undefined} value={dateFromWeb} onChange={(e) => updateOrderFromDate(e.target.value)}></input></span>
                                <span className='mx-2 payment_dates'>To: <input type='date' value={dateToWeb} min={dateFromWeb || undefined} max={moment().format('YYYY-MM-DD')} onChange={(e) => updateOrderToDate(e.target.value)}></input></span>
                                <span><button className='payment_btn_export px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>
                                {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilter()}>Clear</button></span> */}
                                {/* SL-896 Export RTO Orders */}
                                {/* Export button */}
                                <span style={{marginLeft:'10px'}}><button className="payment_btn_export px-3 py-1 ff_Pop fs-14" id="export_Btn" onClick={() => exportRTOOrders()}>Export</button></span>
                            </div>
                        </div>
                        {/* ****** */}
                    </div>
                    <div className="table-responsive">
                    <table class="ord_table new-table-design" style={{ "width": "100%" }}>
                        <thead>
                            <tr className='table_ord_title_row'>

                                <th className='thead_title' style={{ "width": "10%" }}>Order ID
                                    <br></br>
                                    <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "orderId")} />
                                    <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={(data) => checkevent(data = { "keyCode": 13 }, "orderId")}></i>
                                </th>

                                <th className='thead_title pb-1' style={{ "width": "10%" }}>RTO Date<br></br>
                                </th>

                                <th className='thead_title' style={{ "width": "10%" }}>Product image</th>

                                <th className='thead_title' style={{ "width": "25%" }}>Product Name & SKU
                                <br/>
                                    <OrderSKUSearch 
                                    filterSearch={filterSearch}
                                    searchNewEnq={setorderName}
                                    from={"orders"}
                                    flag="Order" // set flag
                                    apiCall={ApiCalling}
                                    apiurl="searchSellerOrdersFilter"
                                    ordersSearchParam={globalFilter}
                                    data="filedData"
                                    totalRcordId={totalRcordId}
                                    searchByKeyword={searchByKeyword}
                                    />
                                </th>

                                <th className='thead_title' style={{ "width": "10%" }}>RTO Status</th>

                                <th className='thead_title' style={{ "width": "12%" }}>Tracking Details</th>

                                    <th className='thead_title' style={{ "width": "10%" }}>RTO Address

                                        <div className="dropdown-wrapper">
                                            <select
                                                value={addressName}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setAddressName(value);
                                                    //Immediately trigger search after selection
                                                    checkevent({ keyCode: 13 }, "rtoaddress", value);
                                                }}
                                            >
                                                <option value="">All</option>
                                                {stateData?.addresses?.data.map((address) => (
                                                    <option key={address._id} value={address.firstName}>
                                                        {address.firstName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </th>
                                </tr>

                        </thead>
                        <tbody>

                            {allRevokes.length > 0 ? allRevokes.map((item, index) => {
                                let baseImg;
                                let date = new Date(item.updatedAt);
                                let d = date.toUTCString(item.updatedAt);
                                let newd = d.substr(4, 12)
                                //<Start-Here> RTO Date Ticket : SL-766
                                const mRTODate = item.rtoDate
                                                    ? new Date(item.rtoDate).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                        })
                                                    : null;
                                //</End-Here> RTO Date Ticket : SL-766 
                                let OrderDate = new Date(item.orderPlaceDate);
                                    OrderDate = OrderDate.toUTCString(item.orderPlaceDate);
                                    OrderDate = OrderDate.substr(4, 12);

                                if (item.products.length > 0 && item.products[0].productId) {
                                    item.products[0].productId.images.map((item) => {
                                        if (item.baseImage === true) {
                                            if (item.image.startsWith("products")) {
                                                baseImg = item.image;
                                            }
                                            else {
                                                let img = item.image.substr("41")
                                                baseImg = img;
                                            }
                                        }
                                    })
                                    return (
                                        <OrderCardWeb id={index}
                                            type="New-Orders"
                                            nicknameAdd={item.products && item.products[0] && item.products[0].vendorDetails && item.products[0].vendorDetails.addrName ? item.products[0].vendorDetails.addrName : undefined}
                                            lead={item._id}
                                            key={item._id}
                                            date={mRTODate != null ? mRTODate : newd}//SL-766
                                            pdetail={detail}
                                            url={item.products[0].productId.urlKey}
                                            popupdetailVis={setpopupVisibilityDetail}
                                            revokes={item.products[0].revokes}
                                            orderId={item.orderId}
                                            productName={item.products[0].productId.productName}
                                            sku={item.products[0].productId.SKU}
                                            price={item.purchase_price}
                                            quantity={item.products[0].quantity}
                                            status={item.status}
                                            invoices={item.products[0].tracks}
                                            image={baseImg}
                                            revokeReason={item.revoke}
                                            vendor={item.vendor}
                                            pro={item.products[0]}
                                            popupVisibility={setpopupVisibilitytrackWeb}
                                            fun={trackPopupWeb}
                                            reportUndeliveredFunc={reportUndeliveredFunc}
                                            handleReportRto={handleReportRto}
                                            OrderDate={OrderDate}
                                            from="rto"
                                            //SL-950
                                            onTransitFetched={(_id,detail, orderId, trackNo) => {
                                                setSelectedPopupId(_id);
                                                setSelectedTransitDetail(detail);
                                                setselectedtrackOrderWeb(orderId);
                                                setselectedTrackwithin(trackNo);
                                            }}
                                        />
                                    )
                                }
                                else {
                                    console.log(index)
                                    return (
                                        <OrderCardWeb id={index}
                                            type="New-Orders"
                                            key={item._id}
                                            lead={item._id}
                                            orderId={item.orderId}
                                            status="noprodetail"
                                        />
                                    )
                                }

                            }) : ennewloader === "none" ? (
                              <>
                                <tr className="order-no-results-row">
                                  <td colSpan={6} className="order-no-results-cell">No Results Found</td>
                                </tr>
                              </>
                            ) : null}
                        </tbody>
                    </table>
                    </div>
                    {/* </Container> */}



                    <div class="d-flex justify-content-center" id="enNewLoader" >
                        <div style={{ "display": ennewloader }}>
                            <MainLoader/>
                        </div>
                    </div>

                    <PaginationCom
                        number={allRecords}
                        activ={selectedPage}
                        paginate={paginate}
                        comp={compforPaginationweb}
                    />




                </div>
                {/* Track detail for web | Ticket : SL-950 */}
                {isPopupTrackVisWeb == 'block' && 
                <div id="popupTrackweb" className={`overlay ${isPopupTrackVisWeb == 'block' ? 'visible' : ''}`} style={{ "display": "block" }}>
                    <TrackOrderPopup
                    type="New-Orders"
                    id={selectedPopupId}
                    trackDetail={selectedTransitDetail}
                    popupVisibility={setpopupVisibilitytrackWeb}
                    /> 
                </div>}

                <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
                    <Popup
                        description={productDetail[0].description}
                        sdescription={productDetail[0].shortDescription}
                        descriptionNew={productDetail[0].descriptionNew}
                        specificationNew={productDetail[0].specificationNew}
                        name={productDetail[0].productName}
                        price={null}
                        SKU={productDetail[0].SKU}
                        popupVisibility={setpopupVisibilityDetail}
                        images={productDetail[0].images}
                        from="categories"
                        videos={productDetail[0].videos}
                        fixedImage={true}
                    />
                </div>

            </div>
        </>

    )
}

export default Revoked_InTransit;